/**
 * When a map tile was tapped (MapsPage), read once by the map page so an open can be timed end to end: tap -> mount ->
 * build gate -> build -> first frame (`map.open` in FestivalMap3D). Only taps on the Maps page set it; a deep link or an
 * event page's map button opens without one and logs the mount-relative parts alone.
 */
let tapAt = null;
export function markMapTap() {
  tapAt = performance.now();
}
export function takeMapTap() {
  const t = tapAt;
  tapAt = null;
  return t;
}
